// Vendor
import { ElementRef, EventEmitter, NgZone } from '@angular/core';
import { finalize } from 'rxjs/operators';
import Sortable from 'sortablejs';
// Constants / utils
import { COMPARABLES_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { disablePointerEvents, enablePointerEvents } from 'NewAngular/utils/sortable-utils';
// Services
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { SecuritiesService } from '../../services/securities.service';
// Components
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
import * as i0 from "@angular/core";
import * as i1 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i2 from "../../services/securities.service";
import * as i3 from "../../../../../../search/static/search/ts/features/add-button-autocomplete/add-button-autocomplete.component";
import * as i4 from "@angular/common";
import * as i5 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i6 from "../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
import * as i7 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i8 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i9 from "../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = ["comparablesContainer"];
const _c1 = (a0, a1) => ({ "plate-purple": a0, "plate-gray": a1 });
function ComparablesModalComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵlistener("click", function ComparablesModalComponent_div_6_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.restoreDefaults()); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "Restore Defaults");
    i0.ɵɵelementEnd()();
} }
function ComparablesModalComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "div", 14);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "div", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.loadingMessage);
} }
function ComparablesModalComponent_div_11_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24)(1, "div", 25)(2, "div", 26)(3, "div", 27)(4, "div", 28);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 29);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 30)(9, "div", 31);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(10, "svg", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(11, "div", 32);
    i0.ɵɵlistener("click", function ComparablesModalComponent_div_11_div_10_Template_div_click_11_listener() { const index_r5 = i0.ɵɵrestoreView(_r4).index; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.removeRelatedSecurity(index_r5)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(12, "svg", 8);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const comparable_r6 = ctx.$implicit;
    const index_r5 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c1, comparable_r6.securityType !== "index" && index_r5 + 1 <= ctx_r1.maxDisplayComparables, comparable_r6.securityType === "index"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2("", index_r5 + 1, ". ", comparable_r6.displaySecurityId);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(comparable_r6.name);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-reorder-up");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-close");
} }
function ComparablesModalComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16)(1, "div", 17)(2, "div", 18)(3, "p");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "div", 19);
    i0.ɵɵelementStart(6, "ycn-add-button-autocomplete", 20);
    i0.ɵɵlistener("submitHandler", function ComparablesModalComponent_div_11_Template_ycn_add_button_autocomplete_submitHandler_6_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.autocompleteHandler($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 21)(8, "div", 22, 0);
    i0.ɵɵtemplate(10, ComparablesModalComponent_div_11_div_10_Template, 13, 9, "div", 23);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(11, "div", 19);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.modalText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("searchType", ctx_r1.searchType);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r1.relatedSecurities)("ngForTrackBy", ctx_r1.trackBySecurityId);
} }
/**
 * Comparables Modal Component
 *
 * Modal with a security autocomplete bar and a sortable list of the related securities for a security.
 *
 * Input Properties:
 *  benchmarkSecurityId: ID of the security benchmark.
 *  maxComparables: Max number of securities supported by the list.
 *  maxDisplayComparables: Max number of display securities to highlight.
 *  relatedSecurities: Initial list of related securities. If empty, it'll try to fetch them.
 *  searchType: Search type to modify the results for the autocomplete.
 *  securityId: Current security ID.
 *  shouldReloadPage: Whether the page should reload once related securities have been successfully updated.
 *  showRestoreDefaults: Flag to show the Restore Defaults button.
 *
 * Output Properties:
 *  submitModalHandler: Handler for the modal submit action.
 */
export class ComparablesModalComponent {
    constructor(featureService, securitiesService, ngZone) {
        this.featureService = featureService;
        this.securitiesService = securitiesService;
        this.ngZone = ngZone;
        this.relatedSecurities = [];
        this.shouldReloadPage = false;
        this.submitHandler = new EventEmitter();
        this.loadingMessage = null;
        this.open = false;
        this.sortableInitialized = false;
        this.errorText = '';
        this.originalRelatedSecurities = [];
        this.defaultRelatedSecurities = [];
        this.USER = window.USER;
        this.open = false;
    }
    ngOnInit() {
        if (!this.USER.authenticated) {
            return;
        }
        this.getDefaultRelatedSecurities(this.securityId);
        if (this.relatedSecurities.length === 0) {
            this.getUserRelatedSecurities(this.securityId);
        }
        else {
            this.originalRelatedSecurities = [...this.relatedSecurities];
        }
    }
    /**
     * Opens the modal and initializes `Sortable`.
     */
    openModal() {
        if (!this.featureService.userHasFeatures([COMPARABLES_FEATURE])) {
            this.featureNeededComponent.openModal(COMPARABLES_FEATURE);
            return;
        }
        this.relatedSecurities = [...this.originalRelatedSecurities];
        if (!this.sortableInitialized) {
            this.initializeSortable();
        }
        this.errorText = '';
        this.open = true;
    }
    /**
     * Closes the modal and restores the original security list.
     */
    closeModal() {
        this.open = false;
    }
    /**
     * Validates and updates the related securities list for the user. Then emits `submitHandler`.
     */
    submit() {
        if (this.relatedSecurities.length > this.maxComparables) {
            this.errorText = `No more than ${this.maxComparables} comparables are allowed.`;
            return;
        }
        // If the lists are the same, don't submit.
        const relatedSecurityIds = this.relatedSecurities.map((sec) => sec.securityId);
        const originalRelatedSecurityIds = this.originalRelatedSecurities.map((sec) => sec.securityId);
        const securityIdsMatch = originalRelatedSecurityIds.every((originalSec, index) => originalSec === relatedSecurityIds[index]);
        if (relatedSecurityIds.length === originalRelatedSecurityIds.length && securityIdsMatch) {
            this.closeModal();
            return;
        }
        this.submitHandler.emit(this.relatedSecurities);
        this.originalRelatedSecurities = [...this.relatedSecurities];
        // Update the user related securities
        this.loadingMessage = this.shouldReloadPage ? 'Updating Comparables' : null;
        this.securitiesService.putUserRelatedSecurities(this.securityId, relatedSecurityIds).subscribe({
            next: () => {
                this.loadingMessage = this.shouldReloadPage ? 'Reloading' : null;
                if (this.shouldReloadPage)
                    window.location.reload();
            },
            error: () => {
                this.loadingMessage = null;
                this.errorText = 'Problem updating comparables.';
            },
        });
    }
    /**
     * Gets the default related securities for the security.
     *
     * @param securityId: Security ID.
     */
    getDefaultRelatedSecurities(securityId) {
        this.securitiesService.getRelatedSecurities(securityId).subscribe({
            next: (securities) => {
                this.defaultRelatedSecurities = securities;
            },
            error: () => {
                this.errorText = 'Error getting related securities.';
            },
        });
    }
    /**
     * Gets the User related securities for the security.
     *
     * @param securityId: Security ID.
     */
    getUserRelatedSecurities(securityId) {
        this.loadingMessage = 'Loading Comparables';
        this.securitiesService
            .getUserRelatedSecurities(securityId)
            .pipe(
        // Finalize gets called after both `next` and after `error`
        finalize(() => {
            this.loadingMessage = null;
        }))
            .subscribe({
            next: (securities) => {
                this.relatedSecurities = securities;
                this.originalRelatedSecurities = [...this.relatedSecurities];
            },
            error: () => {
                this.errorText = 'Error getting related securities.';
            },
        });
    }
    /**
     * Reset the error text and set the default securites as related securities.
     */
    restoreDefaults() {
        this.errorText = '';
        this.relatedSecurities = [...this.defaultRelatedSecurities];
    }
    /**
     * Removes a related security from the list.
     *
     * @param index: Index of the removed security.
     */
    removeRelatedSecurity(index) {
        this.errorText = '';
        this.relatedSecurities.splice(index, 1);
    }
    /**
     * Handler for the security autocomplete input. Triggerd when a security from the dropdown results list is
     * selected.
     *
     * @param securityObject: Selected security.
     */
    autocompleteHandler(securityObject) {
        if (!securityObject)
            return;
        let error;
        const newUserRelatedSecurity = {
            securityId: securityObject.search_id,
            displaySecurityId: securityObject.display_security_id,
            name: securityObject.name,
            securityType: securityObject.type,
        };
        // Can't relate security to itself or benchmark.
        if (newUserRelatedSecurity.securityId === this.securityId) {
            error = "You can't relate a security to itself.";
        }
        if (newUserRelatedSecurity.securityId === this.benchmarkSecurityId) {
            error = "You can't relate a security to the security's benchmark.";
        }
        // Check if the security is already in the list.
        const existingIndex = this.relatedSecurities.findIndex((sec) => sec.securityId === newUserRelatedSecurity.securityId);
        if (existingIndex !== -1) {
            error = `${newUserRelatedSecurity.securityId} already in the list.`;
        }
        // Check if already at max comparables
        if (this.relatedSecurities.length >= this.maxComparables) {
            error = `No more than ${this.maxComparables} comparables are allowed.`;
        }
        if (error) {
            this.errorText = error;
            return;
        }
        this.relatedSecurities.splice(0, 0, newUserRelatedSecurity);
        this.errorText = '';
    }
    /**
     * Updates the ordering of the related securities.
     * @param oldIndex: Old list index.
     * @param newIndex: New list index.
     */
    updateOrdering(oldIndex, newIndex) {
        if (oldIndex !== undefined && newIndex !== undefined) {
            this.relatedSecurities.splice(newIndex, 0, this.relatedSecurities.splice(oldIndex, 1)[0]);
        }
    }
    /**
     * Sets up Sortable drag and drop for the comparables list.
     */
    initializeSortable() {
        this.ngZone.runOutsideAngular(() => {
            Sortable.create(this.comparablesContainer.nativeElement, {
                handle: '.btn-reorder-up',
                scroll: false,
                animation: 150,
                onUpdate: (evt) => {
                    // The Sortable instance is created outside of Angular, so we need to run the update inside the Angular zone.
                    this.ngZone.run(() => {
                        this.updateOrdering(evt.oldIndex, evt.newIndex);
                    });
                },
                onStart: () => {
                    // Prevent pointer-events on btn classes on click in container for tooltip/sortable bug
                    disablePointerEvents(document, 'plate-container');
                },
                onEnd: () => {
                    enablePointerEvents(document, 'plate-container');
                },
            });
        });
        this.sortableInitialized = true;
    }
    /**
     * Resets the original related securities when the list is updated from an external source.
     *
     * @param newRelatedSecurities: New related securities list.
     */
    setOriginalRelatedSecurities(newRelatedSecurities) {
        this.originalRelatedSecurities = newRelatedSecurities;
    }
    trackBySecurityId(index, comparable) {
        return comparable.securityId;
    }
}
ComparablesModalComponent.ɵfac = function ComparablesModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ComparablesModalComponent)(i0.ɵɵdirectiveInject(i1.FeatureService), i0.ɵɵdirectiveInject(i2.SecuritiesService), i0.ɵɵdirectiveInject(i0.NgZone)); };
ComparablesModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ComparablesModalComponent, selectors: [["ycn-comparables-modal"]], viewQuery: function ComparablesModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(FeatureNeededComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.comparablesContainer = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.featureNeededComponent = _t.first);
    } }, inputs: { benchmarkSecurityId: "benchmarkSecurityId", maxComparables: "maxComparables", maxDisplayComparables: "maxDisplayComparables", relatedSecurities: "relatedSecurities", searchType: "searchType", securityId: "securityId", shouldReloadPage: "shouldReloadPage", showRestoreDefaults: "showRestoreDefaults", modalText: "modalText" }, outputs: { submitHandler: "submitHandler" }, standalone: false, decls: 14, vars: 8, consts: [["comparablesContainer", ""], [3, "closeModalHandler", "open", "requiresAction"], [1, "modal-header"], [1, "modal-title"], [1, "modal-header-actions"], [1, "modal-header-action"], ["class", "btn btn-modal-header", 3, "click", 4, "ngIf"], [1, "btn", "btn-modal-header", "btn-close", 3, "click"], ["ycnIcon", "", 3, "name"], ["class", "loader", 4, "ngIf"], ["class", "modal-body", 4, "ngIf"], [3, "cancelHandler", "submitHandler", "errorText", "submitButtonText"], [1, "btn", "btn-modal-header", 3, "click"], [1, "loader"], [1, "loader-message"], [1, "loader-spinner"], [1, "modal-body"], [1, "modal-section"], [1, "form-row"], [1, "divider-horizontal"], [3, "submitHandler", "searchType"], [1, "form-row", "user-select-none"], [1, "plates", "plates-view-list"], ["class", "plate-container", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "plate-container"], [1, "plate", 3, "ngClass"], [1, "plate-header"], [1, "plate-title"], [1, "plate-title-abbr"], [1, "plate-title-name"], [1, "plate-controls"], ["ycnTooltip", "", "tooltipTitle", "Reorder", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-lightgray", "btn-reorder-up", "plate-control"], ["ycnTooltip", "", "tooltipTitle", "Remove", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-lightgray", "plate-control", 3, "click"]], template: function ComparablesModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 1);
        i0.ɵɵlistener("closeModalHandler", function ComparablesModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "div", 2)(2, "div", 3);
        i0.ɵɵtext(3, "Edit Comparables");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4)(5, "div", 5);
        i0.ɵɵtemplate(6, ComparablesModalComponent_div_6_Template, 3, 0, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 5)(8, "div", 7);
        i0.ɵɵlistener("click", function ComparablesModalComponent_Template_div_click_8_listener() { return ctx.closeModal(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(9, "svg", 8);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵtemplate(10, ComparablesModalComponent_div_10_Template, 4, 1, "div", 9)(11, ComparablesModalComponent_div_11_Template, 12, 4, "div", 10);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(12, "ycn-simple-modal-footer", 11);
        i0.ɵɵlistener("cancelHandler", function ComparablesModalComponent_Template_ycn_simple_modal_footer_cancelHandler_12_listener() { return ctx.closeModal(); })("submitHandler", function ComparablesModalComponent_Template_ycn_simple_modal_footer_submitHandler_12_listener() { return ctx.submit(); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(13, "ycn-feature-needed");
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.open)("requiresAction", true);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.showRestoreDefaults);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("name", "icon-close");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.loadingMessage);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loadingMessage);
        i0.ɵɵadvance();
        i0.ɵɵproperty("errorText", ctx.errorText)("submitButtonText", "Update");
    } }, dependencies: [i3.AddButtonAutocompleteComponent, i4.NgClass, i4.NgForOf, i4.NgIf, i5.IconDirective, i6.FeatureNeededComponent, i7.ModalBaseComponent, i8.SimpleModalFooterComponent, i9.TooltipDirective], encapsulation: 2 });
